import apiConfig from '@constants/apiConfig';
import LogManagementListPage from '.';

// Nguồn ra-log-monitor-cms: sitePathConfig.logManagement.path = '/logs' ("Quản lí đơn hàng").
export default {
    logManagementListPage: {
        path: '/logs',
        auth: true,
        component: LogManagementListPage,
        permission: [apiConfig.logs.getList.permissionCode],
        pageOptions: {
            objectName: 'Log',
        },
    },
};
